import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";

export default class RemainingTimeDisplay extends VideoJsAdapter.getComponent('RemainingTimeDisplay') {
  constructor(player, options = {}) {
    super(player, options);
  }


  // will need to try to delete this method as it is not used anymore on videojs
  // updateTextNode is method from class DisplayTime
  // https://docs.videojs.com/control-bar_time-controls_time-display.js.html#line15
  formatTime_(time) {
    super.updateTextNode_(time);
  }

  updateContent(event) {
    if(this.player_.remainingTime() == Infinity) {
      return;
    }

    super.updateContent(event);
  }
}

VideoJsAdapter.registerComponent('VpRemainingTimeDisplay', RemainingTimeDisplay);
